import React, { createContext, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { boardFetch, setToken, clearToken, getToken } from "./api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const BoardAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=authed
  useEffect(() => {
    if (!getToken()) {
      setUser(false);
      return;
    }
    boardFetch("/auth/me")
      .then(setUser)
      .catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const data = await boardFetch("/auth/login", { method: "POST", json: { email, password } });
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };
  const logout = () => {
    clearToken();
    setUser(false);
    window.location.assign("/board/login");
  };

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
};

export const RequireAuth = ({ children }) => {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#0a0a0a] text-white/40" data-testid="board-loading">
        <span className="animate-pulse text-sm uppercase tracking-[0.3em]">Cockpit wird geladen…</span>
      </div>
    );
  if (!user) return <Navigate to="/board/login" replace />;
  return children;
};
